import { apiRequest } from "@/api";
import Peer from "peerjs";
import SoundCall from "@/assets/call-ringtone.ogg";
const audio = new Audio(SoundCall);

const state = {
  call: undefined,
  peerId: undefined,
  myPeer: undefined,
  remoteStreamMedia: {
    audio: true,
    video: true,
  },
  showConversation: false,
  messages: [],
  messageNotif: false,
  socketAddr: undefined,
  RefVideoChatContent: null,
};

const mutations = {
  SOCKET_User_leaveChat(state, data) {
    console.log("---->", data);
    if (state.call) {
      state.call.close();
      state.call = undefined;
    }
  },
  SET_CALLONG_SOUND(state, param) {
    if (param == "play") {
      audio.volume = 0.7;
      audio.loop = true;
      audio.play();
    } else {
      audio.pause();
      audio.currentTime = 0;
    }
  },
};

const actions = {
  initPeer: ({ state, commit }) => {
    return new Promise((resolve, reject) => {
      state.myPeer = new Peer({
        host: "peers-server.cleed.ai",
        // host: "localhost",
        port: 443,
        path: "/CleedPeer/cleed_VC",
        debug: 2,
        secure: true,
      });
      resolve();
    });
  },
  SOCKET_User_mediaDevices_Change({ state, dispatch }, data) {
    dispatch("setSnackbar", {
      text: data.message,
      color: "",
      top: true,
      timeout: 2000,
    });
    state.remoteStreamMedia = data;
  },
  SOCKET_User_answer_call({ rootState, commit }, data) {
    rootState.show.callOverlay = false;
    commit("SET_CALLONG_SOUND", "stop");
    rootState.show.videoChat = true;
  },
  SOCKET_User_end_call({ rootState, commit, dispatch }, data) {
    rootState.show.videoChat = false;
    rootState.show.callOverlay = false;
    commit("SET_CALLONG_SOUND", "stop");
    dispatch("setSnackbar", {
      text: "User cancel the call",
      color: "",
      top: true,
      timeout: 2000,
    });
  },
  enableCallSound({ commit }, params) {
    commit("SET_CALLONG_SOUND", params);
  },
  SOCKET_videoChat_user_send_message({ state, dispatch, commit }, data) {
    state.RefVideoChatContent.scrollTop =
      state.RefVideoChatContent.scrollHeight;
    if (!state.showConversation) state.messageNotif = true;
    state.messages.push(data);

    this.dispatch("setNotification", {
      showing: true,
      text: "New message",
      position: "top-right",
      type: "success",
      timeout: 2000,
      closeOnClick: true,
      pauseOnFocusLoss: true,
      pauseOnHover: true,
      draggable: true,
      draggablePercent: 1.5,
      showCloseButtonOnHover: false,
      hideProgressBar: false,
      closeButton: "button",
      icon: {
        iconClass: "v-icon mdi mdi-message-text",
        iconChildren: "",
        iconTag: "i",
      },
      rtl: false,
    });
    commit("VIDEO_SOCKET_VideoChat_newMessage", data);
  },
};

export default { state, mutations, actions };
